import * as Logger from './logger.js'
import { HSComponent } from './component.js';
import styles from './sidebar.css';
import template from './sidebar.html';

class HSSidebar extends HSComponent {
    constructor() { 
        super();
    }
    onLoad() {
        this.loadTemplate(template);
        this.loadStyles(styles);
        const logoutButton = this.shadowRoot.getElementById('logout-button');
        this.onEvent('click', () => this.emit({ type: 'hs-logout' }), logoutButton);
    }
}
customElements.define('hs-sidebar', HSSidebar);
